/**
 * Blog-route predicate for the site shell.
 *
 * The founder ban on scroll-driven animation is UNCONDITIONAL on blog
 * surfaces (docs/BLOG-DESIGN-DIRECTION.md, decision #2): no scroll-jacking,
 * no scroll-scrubbed visuals, no scroll listeners driving anything visual.
 * The brand shell's scroll layer (LenisProvider, ScrollProgress,
 * ScrollActivity) uses this to opt blog routes out entirely.
 *
 * Blog pages serve unprefixed (/blog/...) and under the non-default locale
 * prefixes (/sq/blog/..., /ar/blog/...); /en/blog/* 308s to /blog/* in the
 * middleware, but is matched here too for safety.
 */
import { locales } from "@/lib/i18n/config";

const BLOG_PATH_RE = new RegExp(`^/(?:(?:${locales.join("|")})/)?blog(?:/|$)`);

export function isBlogPath(pathname: string | null | undefined): boolean {
  return pathname != null && BLOG_PATH_RE.test(pathname);
}
